import { useEffect, useRef } from 'react';
import { withWindow } from '@shared/utils/withWindow';

export const useKeycodeListener = (keys: readonly string[], callback: () => void, options?: Partial<Pick<KeyboardEvent, 'altKey' | 'ctrlKey' | 'shiftKey'>>) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const keysKey = keys.join(',');
  const { altKey, ctrlKey, shiftKey } = options ?? {};

  useEffect(() => {
    const match = (event: KeyboardEvent) => {
      if (altKey !== undefined && altKey !== event.altKey) return false;
      if (ctrlKey !== undefined && ctrlKey !== event.ctrlKey) return false;
      if (shiftKey !== undefined && shiftKey !== event.shiftKey) return false;
      return keysKey.split(',').some(k => k === event.key || k === event.code);
    };

    const onDown = (event: KeyboardEvent) => {
      if (match(event)) {
        callbackRef.current();
      }
    };

    withWindow(window => {
      window.addEventListener('keydown', onDown);
    });
    return () => {
      withWindow(window => {
        window.removeEventListener('keydown', onDown);
      });
    };
  }, [keysKey, altKey, ctrlKey, shiftKey]);
};
